<template>
  <div>
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/p3.jpg"
              width="100%"
              alt="蓝鲨 Robor 扭矩大功率足"
            />
          </div>
          <div class="text t3">
            <div class="aniel" :class="{ ani2: a1 }">
              R 取自拉丁語詞根 Robor，意為力量。Blueshark R Series
              搭載高速無刷永磁邊掛電機，它擁有輪轂電機望塵莫及的強大扭力，使整車加速更快，<br />爬坡性能更強，為騎行者帶來駕馭競賽摩托般腎上腺素飆升的快感。
            </div>
          </div>
          <div class="text t3a">
            <div>
              <span class="aniel" :class="{ ani: a2 }">
                <span class="fs_big">5000</span>
                <span class="fs_tiny">w</span>
              </span>
              <br />
              <span class="fs_tiny color_gray aniel" :class="{ ani1: a2 }">
                峰值功率
              </span>
            </div>
            <div>
              <span class="aniel" :class="{ ani: a2 }">
                <span class="fs_big">5500</span>
                <span class="fs_tiny">rpm</span>
              </span>
              <br />
              <span class="fs_tiny color_gray aniel" :class="{ ani1: a2 }">
                最高轉速
              </span>
            </div>
            <div>
              <span class="aniel" :class="{ ani: a2 }">
                <span class="fs_big">201</span>
                <span class="fs_tiny">N·m</span>
              </span>
              <br />
              <span class="fs_tiny color_gray aniel" :class="{ ani1: a2 }">
                扭力
              </span>
            </div>
            <div>
              <span class="aniel" :class="{ ani: a2 }">
                <span class="fs_big">80</span>
                <span class="fs_tiny">km/h</span>
              </span>
              <br />
              <span class="fs_tiny color_gray aniel" :class="{ ani1: a2 }">
                極速
              </span>
            </div>
            <div>
              <span class="aniel" :class="{ ani: a2 }">
                <span class="fs_big">40</span>
                <span class="fs_tiny">%</span>
              </span>
              <br />
              <span class="fs_tiny color_gray aniel" :class="{ ani1: a2 }">
                爬坡性能
              </span>
            </div>
            <div>
              <span class="aniel" :class="{ ani: a2 }">
                <span class="fs_big">4.9</span>
                <span class="fs_tiny">s</span>
              </span>
              <br />
              <span class="fs_tiny color_gray aniel" :class="{ ani1: a2 }">
                0-50 km/h 加速
              </span>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/p3-2.jpg"
              width="100%"
              alt="蓝鲨 Robor 扭矩大功率足"
            />
          </div>
          <div class="text t3">
            <div>
              20
              鉻錳鈦合金齒輪組透過兩級變速，將動力傳遞給驅動輪，不僅避免鏈傳動系統的多邊形效應，與帶傳動相比又具有傳動比穩定、<br />傳動效率高和使用壽命長的優勢，在傳動方式上比中置馬達更具優越性。
            </div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      a1: false,
      a2: false,
      swiperOption: {
        loop: false,
        resistanceRatio: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    startani1() {
      this.a1 = true
    },
    startani2() {
      this.a2 = true
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/swiper.less';
.swiper-pagination {
  bottom: 5vw !important;
}
.t3 {
  top: 180px;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  .t3_1 {
    margin-bottom: 10px;
  }
  .t3_2 {
    margin-bottom: 20px;
  }
}
.t3a {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  left: 20vw;
  bottom: 10vw;
  right: 20vw;
  text-align: center;
}

.aniel {
  position: relative;
  opacity: 0;
}
.ani {
  animation: tani 1s forwards;
}
.ani1 {
  animation: tani 1s forwards 0.1s;
}
.ani2 {
  animation: tani 1s forwards 0.2s;
}

@keyframes tani {
  from {
    top: 60px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/swiper_tw/swiper3.vue